const SilverBase = require('silver-base')

/**
 * SilverGoldLog
 * @class
 */
export class SilverGoldLog extends SilverBase {
  constructor(opt) {
    super()
    if (!opt.code || !opt.key) {
      throw 'code and key is not defined'
    }

    const _this = this
    if (!window.goldlog) {
      setTimeout(function() {
        _this.goldlog = window.goldlog || null
      }, 200)
    }

    this.goldlog = window.goldlog || null
    if (!window.goldlog_queue) {
      window.goldlog_queue = []
    }

    this.code = opt.code
    this.key = opt.key
    this.globalData = {}
  }
  /**
   * getName 获取组件名称
   * @memberOf SilverGoldLog.prototype
   * @method getName
   * @return {String}
   */
  getName() {
    return 'SilverGoldLog'
  }

  _escape(obj) {
    let _obj = {}
    for (let k in obj) {
      if (obj.hasOwnProperty(k)) {
        const value = encodeURIComponent(obj[k])
        k = encodeURIComponent(k)
        _obj[k] = value
      }
    }
    return _obj
  }

  _makeObj(param) {
    let obj = {}
    if (Array.isArray(param)) {
      param.forEach(function(item) {
        if (Array.isArray(item)) {
          obj[item[0]] = item[1]
        } else if (item && typeof item === 'object') {
          for (let k in item) {
            if (item.hasOwnProperty(k)) {
              obj[k] = item[k]
              break
            }
          }
        }
      })
    } else if (param && typeof param === 'object') {
      obj = param
    }
    return obj
  }

  _makeString(obj) {
    let p = ''
    for (let k in obj) {
      if (obj.hasOwnProperty(k)) {
        p += k+'='+obj[k]+'&'
      }
    }
    return p.slice(0, p.length-1)
  }

  _merge(obj) {
    const globalData = this.globalData
    for (let k in globalData) {
      if (globalData.hasOwnProperty(k) && !obj[k]) {
        obj[k] = globalData[k]
      }
    }
    return obj
  }

  setGlobal(param) {
    this.globalData = this._escape(this._makeObj(param))
    return this
  }

  exposure(param) {
    if (!window.goldlog_queue) {
      return this
    }
    window.goldlog_queue.push({
      action: "goldlog.record",
      arguments: [this.code, 'EXP', this._getParam(param), this.key]
    })
    return this
  }

  event(param) {
    if (!this.goldlog || !this.goldlog.record) {
      return this
    }
    this.goldlog.record(this.code, 'CLK', this._getParam(param), this.key)
    return this
  }
  _getParam(param) {
    return this._makeString(this._merge(this._escape(this._makeObj(param))))
  }
}



// WEBPACK FOOTER //
// ./~/@ali/silver-gold-log/lib/index.js